import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { SettingsStyles } from '~src/settings/styles/CommonStyles';

import { fetchCustomDomainSetting } from '../serverAPI/requests/GetCustomDomainRequest';
import { CustomDomainSettingResponse } from '../serverAPI/types/CustomDomainTypes';
import { AddCustomDomainView } from './AddCustomDomainView';
import { ConfiguredCustomDomainView } from './ConfiguredCustomDomainView';
import { UploadSSLCertificateView } from './UploadSSLCertificateView';
import { ValidateCnameView } from './ValidateCnameView';

export interface CustomDomainSettingState {
  showAddCustomDomainView: boolean;
  customDomainSetting: CustomDomainSettingResponse;
}

export class CustomDomainSettingView extends React.PureComponent<{}, CustomDomainSettingState> {
    public constructor(props: {}) {
        super(props);
        this.state = {
          showAddCustomDomainView: true,
          customDomainSetting: {
            site_luid: '',
            custom_domain: '',
            intermediate_domain: '',
            status: '',
            request_initiation_date: undefined,
            tls_certificate_uploaded_date: false,
            tls_certificate_expiry_date: undefined
          }
        };
      }

    private renderSetupCustomDomainView() {
        return  <>
          <ButtonWidget buttonType={ButtonType.Destructive}
          testId='cancel-custom-domain-on-site-button'
          className='tb-outline-button'
          onClick ={() => this.setState({showAddCustomDomainView: true})}>
            {Messages.cancel()}
          </ButtonWidget>

        <div className={SettingsStyles.settingsGroupDescription}>
          <AddCustomDomainView customDomainSetting={this.state.customDomainSetting} triggerFetchCustomDomain={this.fetchAndRefreshCustomDomainSetting}/>
          <ValidateCnameView  customDomainSetting={this.state.customDomainSetting} triggerFetchCustomDomain={this.fetchAndRefreshCustomDomainSetting}/>
          <UploadSSLCertificateView  customDomainSetting={this.state.customDomainSetting} triggerFetchCustomDomain={this.fetchAndRefreshCustomDomainSetting}/>
        </div>
      </>;
    }

    public componentDidMount() {
      this.fetchAndRefreshCustomDomainSetting();
    }

    private fetchAndRefreshCustomDomainSetting() {
      fetchCustomDomainSetting(this.getSiteLuid()).then((res)  => {
          this.setCustomDomain(res);
        }).catch(err => {
          /*
            TODO: Add a 'Toast widget' when GET customDomainSetting fails.
            Skipping this for now as the backend is not ready yet and the toast would pop everytime settings page is rendered.
          */
          //ToastWidget.show({message: 'Fetching custom domain failed', testId: 'toast-fetch-custom-domain-failed', toastType: ToastType.Error});
        });
    }

    private getSiteLuid() {
      return getSessionManagementServiceInstance().sessionSiteLuid();
    }

    private setCustomDomain(res: CustomDomainSettingResponse) {
      const customDomainSettingResponse ={...this.state.customDomainSetting,
        site_luid: res.site_luid,
        custom_domain: res.custom_domain,
        intermediate_domain: res.intermediate_domain,
        cname_verification_status: res.status,
        cname_last_verified_date: res.request_initiation_date,
        tls_certificate_uploaded: res.tls_certificate_uploaded_date,
        tls_certificate_expiry_date: res.tls_certificate_expiry_date};

      this.setState({customDomainSetting: customDomainSettingResponse});
    }

    public render() {
        return <>
        { this.state.customDomainSetting?.tls_certificate_uploaded_date ? <ConfiguredCustomDomainView customDomainSetting={this.state.customDomainSetting} triggerFetchCustomDomain={this.fetchAndRefreshCustomDomainSetting}/> :
        <div>
          { (this.state.customDomainSetting?.intermediate_domain || !this.state.showAddCustomDomainView) ?
          this.renderSetupCustomDomainView():
          <ButtonWidget buttonType={ButtonType.Outline}
          testId='add-custom-domain-on-site-button'
          className='tb-outline-button'
          onClick={() => this.setState({showAddCustomDomainView: false})}>
              {Messages.CustomDomainSetting_addButton()}
          </ButtonWidget>  }
        </div>
      }
      </>;
    }
}